<template>
  <span class="datespan" style="padding: 1px 4px 1px 4px; border-radius: 4px" :class="{'normal': state == 0, 'warning': state == 1, 'error': state == 2}">
    {{ formattedDate }}
  </span>
</template>

<script>
export default {
  props: {
    date: {
      type: Date,
      default: null
    }
  },
  computed: {
    yesterday(){
      let d = new Date( this.date )
      d.setDate( d.getDate() - 1 )

      return d
    },
    lastWeek(){
      let d = new Date( this.date )
      d.setDate( d.getDate() - 4 )

      return d
    },
    state() {
      // 0- ok, 1 - warn, 2 - urgent
      let today = new Date()

      if (today >= this.yesterday) {
        return 2
      } else if (today >= this.lastWeek ) {
        return 1
      } else {
        return 0
      }
    },
    formattedDate(){
      let day = this.date.getDate()
      day = day >= 10 ? day : '0'+day
      let month = this.date.getMonth() + 1
      month = month >= 10 ? month : '0'+month

      return `${day}-${month}-${this.date.getFullYear()}`
    }

  }
}
</script>


.<style scoped>
.datespan {
  color: white;
}

.datespan.normal {
  color: inherit !important;
}
</style>